module.exports = __webpack_public_path__ + "cc9ae9d85ac72774ee94ba751ef71341.png";